export default __webpack_public_path__ + "static/quote-video-4-29c9d4b813a23629534718ed0a2d26aa.mp4";